/**
 * About Us: English & French (source: Who we are ENG.pdf, Qui sommes-nous.pdf).
 */

export const aboutCopy = {
  en: {
    pageTitle: 'About Us',
    headline: 'Who We Are',
    tagline: 'SIMO Pay · Simply Mobility Pay',
    intro1:
      'SIMO Pay is a next generation fintech and mobility platform built to connect Morocco, Africa, Europe, and the global diaspora through seamless digital payments.',
    intro2:
      'Our mission is simple: make payments easier, smarter, and more accessible for everyone, from local taxi drivers and merchants to international travelers and millions of diaspora users sending money back home.',
    ecosystemLead: 'We are building a unified financial ecosystem powered by:',
    ecosystemBullets: [
      'QR code payments',
      'Digital wallets',
      'Mobility integrations',
      'Embedded financial technologies designed specifically for emerging and high growth markets',
    ],
    expertiseLead: 'SIMO Pay was founded by a team with deep expertise in:',
    expertiseBullets: [
      'Cross border remittance',
      'Financial technologies',
      'Mobility and transportation systems',
      'Digital payment infrastructure',
      'Large scale API integrations',
    ],
    leadership:
      'Our leadership team has successfully launched and scaled fintech and mobility solutions across North America, Europe, the Middle East, and India.',
    whatWeDoTitle: 'What We Do',
    whatWeDoLead: 'SIMO Pay enables users to:',
    whatWeDoBullets: [
      'Send and receive money instantly',
      'Pay via QR codes',
      'Access mobility payment solutions',
      'Enable digital payments for taxis and drivers',
      'Pay at local shops and restaurants',
      'Access seamless travel and transportation services',
    ],
    mobility:
      'In parallel, we are transforming the mobility ecosystem through our proprietary “Driver Tools” technologies, combining payments, dispatch systems, and digital booking channels into one integrated platform.',
    kiosks:
      'Our technology also powers next generation digital mobility kiosks across Morocco, allowing users to book rides and access transportation services instantly, even without mobile applications.',
    visionTitle: 'Our Vision',
    vision1:
      'We believe Africa and the MENA region deserve financial infrastructure built for the realities of modern mobility, tourism, and cross border commerce.',
    visionLead: 'Our ambition is to evolve SIMO Pay into:',
    visionBullets: [
      'The leading mobility payment platform in Morocco',
      'A trusted digital wallet for the African diaspora',
      'A regional fintech infrastructure provider',
      'A future NeoBank serving Africa and emerging markets',
    ],
    mantra: 'Built in Morocco. Designed for Africa. Connected to the World.',
    closing1:
      'SIMO Pay combines global technology expertise with strong local execution, partnerships, and market knowledge to create solutions tailored for both businesses and consumers.',
    closing2: 'We are not just building a payment app.',
    closing3:
      'We are building the future financial infrastructure for mobility and everyday commerce across Africa.',
  },
  fr: {
    pageTitle: 'Qui sommes nous',
    headline: 'Qui sommes nous',
    tagline: 'SIMO Pay · Simply Mobility Pay',
    intro1:
      'SIMO Pay est une plateforme fintech et mobilité de nouvelle génération, conçue pour connecter le Maroc, l’Afrique, l’Europe et les diasporas à travers des solutions de paiement digitales simples, rapides et accessibles.',
    intro2:
      'Notre mission est claire : faciliter les paiements du quotidien pour tous, des chauffeurs de taxi et commerçants locaux aux voyageurs internationaux, en passant par des millions de membres de la diaspora qui envoient de l’argent à leurs proches au Maroc et en Afrique.',
    ecosystemLead: 'Nous construisons un écosystème financier unifié reposant sur :',
    ecosystemBullets: [
      'Les paiements par QR Code',
      'Les portefeuilles électroniques (e wallets)',
      'Les solutions de paiement dédiées à la mobilité',
      'Les technologies financières intégrées adaptées aux marchés émergents',
    ],
    expertiseLead: 'SIMO Pay a été fondé par une équipe disposant d’une forte expertise dans :',
    expertiseBullets: [
      'Les transferts d’argent internationaux',
      'Les technologies financières',
      'Les systèmes de mobilité et de transport',
      'Les infrastructures de paiement digital',
      'Les intégrations API à grande échelle',
    ],
    leadership:
      'Notre équipe dirigeante a participé au lancement et au développement de solutions fintech et mobilité en Amérique du Nord, en Europe, au Moyen Orient et en Inde.',
    whatWeDoTitle: 'Ce que nous faisons',
    whatWeDoLead: 'SIMO Pay permet aux utilisateurs de :',
    whatWeDoBullets: [
      'Envoyer et recevoir de l’argent instantanément',
      'Payer via QR Code',
      'Accéder à des solutions de paiement pour la mobilité',
      'Digitaliser les paiements pour les taxis et chauffeurs',
      'Payer dans les commerces et restaurants',
      'Accéder à des services de transport et de mobilité de manière fluide',
    ],
    mobility:
      'En parallèle, nous transformons l’écosystème de la mobilité grâce à nos technologies propriétaires appelées « Driver Tools », qui combinent paiements, dispatching et canaux de réservation digitaux au sein d’une plateforme intégrée.',
    kiosks:
      'Notre technologie alimente également une nouvelle génération de bornes digitales de mobilité au Maroc, permettant aux utilisateurs de réserver des trajets et accéder à des services de transport instantanément, même sans application mobile.',
    visionTitle: 'Notre vision',
    vision1:
      'Nous sommes convaincus que l’Afrique et la région MENA ont besoin d’infrastructures financières modernes, pensées pour les réalités de la mobilité, du tourisme et du commerce international.',
    visionLead: 'Notre ambition est de faire de SIMO Pay :',
    visionBullets: [
      'La principale plateforme de paiement dédiée à la mobilité au Maroc',
      'Un portefeuille digital de référence pour les diasporas africaines',
      'Un acteur majeur des infrastructures fintech régionales',
      'Et à terme, une NeoBank panafricaine',
    ],
    mantra: 'Conçu au Maroc. Pensé pour l’Afrique. Connecté au monde.',
    closing1:
      'SIMO Pay combine expertise technologique internationale, exécution locale et partenariats stratégiques afin de créer des solutions adaptées aux besoins des entreprises comme des consommateurs.',
    closing2: 'Nous ne construisons pas simplement une application de paiement.',
    closing3:
      'Nous construisons l’infrastructure financière de demain pour la mobilité et le commerce en Afrique.',
  },
  ar: {
    pageTitle: 'من نحن',
    headline: 'من نحن',
    tagline: 'SIMO Pay · Simply Mobility Pay',
    intro1:
      'سيمو باي هي منصة متكاملة من الجيل التالي للتقنية المالية والتنقل، مصممة لربط المغرب وأفريقيا وأوروبا والشتات العالمي من خلال حلول دفع رقمية سلسة.',
    intro2:
      'مهمتنا بسيطة: جعل المدفوعات أسهل وأذكى وأكثر شمولاً للجميع، من سائقي التاكسي والتجار المحليين إلى المسافرين الدوليين وملايين أبناء الجاليات الذين يرسلون الأموال إلى ذويهم.',
    ecosystemLead: 'نحن نبني نظاماً مالياً موحداً مدعوماً بـ:',
    ecosystemBullets: [
      'مدفوعات QR',
      'المحافظ الرقمية',
      'تكاملات التنقل',
      'تقنيات مالية مدمجة مصممة خصيصاً للأسواق الناشئة وعالية النمو',
    ],
    expertiseLead: 'تأسست سيمو باي على يد فريق يمتلك خبرة عميقة في:',
    expertiseBullets: [
      'التحويلات المالية عبر الحدود',
      'تقنيات الخدمات المالية',
      'أنظمة التنقل والمواصلات',
      'بنية تحتية للمدفوعات الرقمية',
      'تكاملات API على نطاق واسع',
    ],
    leadership:
      'نجح فريق قيادتنا في إطلاق وتوسيع حلول التقنية المالية والتنقل عبر أمريكا الشمالية وأوروبا والشرق الأوسط والهند.',
    whatWeDoTitle: 'ماذا نفعل',
    whatWeDoLead: 'تتيح سيمو باي للمستخدمين:',
    whatWeDoBullets: [
      'إرسال واستقبال الأموال فورياً',
      'الدفع عبر رموز QR',
      'الوصول إلى حلول دفع التنقل',
      'تمكين المدفوعات الرقمية للتاكسي والسائقين',
      'الدفع في المحلات والمطاعم المحلية',
      'الوصول إلى خدمات السفر والمواصلات بسهولة',
    ],
    mobility:
      'في الوقت ذاته، نحوّل منظومة التنقل من خلال تقنياتنا الحصرية "Driver Tools"، التي تجمع بين المدفوعات وأنظمة التوزيع وقنوات الحجز الرقمي في منصة متكاملة واحدة.',
    kiosks:
      'تشغّل تقنيتنا أيضاً أكشاك تنقل رقمية من الجيل التالي عبر المغرب، تتيح للمستخدمين حجز الرحلات والوصول إلى خدمات المواصلات فوراً، حتى بدون تطبيقات الهاتف.',
    visionTitle: 'رؤيتنا',
    vision1:
      'نؤمن بأن أفريقيا ومنطقة الشرق الأوسط وشمال أفريقيا تستحق بنية تحتية مالية مصممة لواقع التنقل الحديث والسياحة والتجارة عابرة الحدود.',
    visionLead: 'طموحنا هو تطوير سيمو باي لتصبح:',
    visionBullets: [
      'منصة الدفع الرائدة للتنقل في المغرب',
      'محفظة رقمية موثوقة لشتات الأفارقة',
      'مزوداً إقليمياً لبنية التقنية المالية التحتية',
      'نيو بنك مستقبلي يخدم أفريقيا والأسواق الناشئة',
    ],
    mantra: 'مصنوع في المغرب. مصمم لأفريقيا. موصول بالعالم.',
    closing1:
      'تجمع سيمو باي بين الخبرة التقنية العالمية والتنفيذ المحلي القوي والشراكات ومعرفة السوق لإنشاء حلول مصممة لكل من الشركات والمستهلكين.',
    closing2: 'نحن لا نبني مجرد تطبيق دفع.',
    closing3:
      'نحن نبني البنية التحتية المالية المستقبلية للتنقل والتجارة اليومية عبر أفريقيا.',
  },
};
